import { render } from "./AutoLogout.vue?vue&type=template&id=2845194d"
import script from "./AutoLogout.vue?vue&type=script&lang=js"
export * from "./AutoLogout.vue?vue&type=script&lang=js"
script.render = render

export default script